import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';
import Table from 'react-bootstrap/Table';

import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


const AddClient = () => {

    const [clid, setClid] = useState("");

    useEffect(() => {
        // Fetch the last clid and increment it
        axios.get("https://react-apis.dotlocalhost.com/getClid.php")
            .then(response => {
                setClid(response.data.clid); // Set the incremented clid
            })
            .catch(error => {
                console.error("There was an error fetching the clid!", error);
            });

        

        // Change background color of the specific sidebar item
        const sidebarItemmain = document.getElementById("clnt");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("adclnt");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7"; // Set the color when this component is loaded
            sidebarItem.style.color = "#000000";
        }

        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItem.style.color = "#000000";
            }
        };

    }, []);






    let history = useNavigate();

    const [data, setData] = useState({
        clientName: "",
        address: "",
        netWeight: ""
    })

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });

        //console.log(data)
    }

    const submitForm = (e) => {
        e.preventDefault();
        const sendData = {
            clientName: data.clientName,
            status: data.status,
            address: data.address,
            email: data.email,
            mobile: data.mobile,
            opening_balance: data.opening_balance,
            clid: clid
        }

        console.log(sendData);

        axios.post('https://react-apis.dotlocalhost.com/client.php', sendData).then((result) => {
            if (result.data.Status == 'Invalid') {
                alert('Invalid User');
            } else {
                history('/viewallclient');
            }
        })

    }

    return(

        <div class="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Add New Client</h3>
                        </div>
                    </div>
            
                    <form onSubmit={submitForm}>

                    <input style={{display:'none'}} type="text" id="clid" name='clid' value={clid} />

                        <Table striped bordered hover style={{fontSize: '12px'}}>
                            <thead>
                                <tr style={{textAlign:'center', backgroundColor:'#C0D4D9', color:'#000000'}}>
                                    <th>#</th>
                                    <th><label>Client Name</label></th>
                                    <th><label>Status</label></th>
                                    <th><label>Address</label></th>
                                    <th><label>Email Address</label></th>
                                    <th><label>Mobile Number</label></th>
                                    <th><label>Opening Balance</label></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td><input type="text" name="clientName" className='form-control' onChange={handleChange} value={data.clientName} autocomplete="off"/></td>
                                    <td>
                                        <select class="form-select" className='form-control' aria-label="Default select example" name="status" onChange={handleChange} value={data.status}>
                                            <option selected>Select Status</option>
                                            <option value="vendor">Vendor</option>
                                            <option value="customer">Customer</option>
                                            <option value="broker">Broker</option>
                                            {/* <option value="3">Three</option> */}
                                        </select>
                                    </td>
                                    <td><input type="text" name="address" className='form-control' onChange={handleChange} value={data.address} autocomplete="off"/></td>                                
                                    <td><input type="text" name="email" className='form-control' onChange={handleChange} value={data.email} autocomplete="off"/></td>                                
                                    <td><input type="text" name="mobile" className='form-control' onChange={handleChange} value={data.mobile} autocomplete="off"/></td>
                                    <td><input type="text" name="opening_balance" className='form-control' onChange={handleChange} value={data.opening_balance} autocomplete="off"/></td>
                                </tr>
                            </tbody>
                        </Table>

                        <div className="row">
                            <div className='col-6'>
                                <div className="d-grid gap-3">
                                    <input type="submit" name="submit" value="Add Client" className="btn btn-primary btn-block" />
                                </div>
                            </div>
                        </div>


                    </form>

                </div>

            </div>
        </div>
    )
}

export default AddClient;